import React from "react";
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { BarChart } from '@mui/x-charts/BarChart';
import Toggle from 'react-toggle'
import "react-toggle/style.css" 
const sizing = {
  margin: { right: 5 },
  width: 300, // Adjust width as needed
  height: 280, // Adjust height as needed
  legend: { hidden: true },
};

  export default ({selectedOtherInterval, setSelectedOtherInterval, otherlist, handleIntervalChange_,ishowToggleGender, setIshowToggleGender }) => {

    const currentYear = new Date().getFullYear();
    const futureYears = Array.from({ length: 5 }, (_, index) => currentYear + index);

    const data = {
      daily: {
        mData: otherlist?.maleData?.res_data.length > 0 ? otherlist?.maleData?.res_data : Array(31).fill(0),
        fData: otherlist?.femaleData?.res_data.length > 0 ? otherlist?.femaleData?.res_data : Array(31).fill(0),
        xLabels: Array.from({ length: 31 }, (_, index) => `Day ${index + 1}`),
      },
      weekly: {
        mData:otherlist?.maleData?.res_data.length > 0 ? otherlist?.maleData?.res_data : Array(7).fill(0),
        fData:otherlist?.femaleData?.res_data.length > 0 ? otherlist?.femaleData?.res_data : Array(7).fill(0),
        xLabels: ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5", "Week 6", "Week 7"],
      },
      monthly: {
        mData:otherlist?.maleData?.res_data.length > 0 ? otherlist?.maleData?.res_data : Array(12).fill(0),
        fData:otherlist?.femaleData?.res_data.length > 0 ? otherlist?.femaleData?.res_data :  Array(12).fill(0),
        xLabels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      },
      yearly: {
        mData: otherlist?.maleData?.res_data?.length > 0 ? otherlist?.maleData?.res_data : Array(futureYears.length).fill(0),
        fData: otherlist?.femaleData?.res_data?.length > 0 ? otherlist?.femaleData?.res_data : Array(futureYears.length).fill(0),
        xLabels: futureYears.length > 0 ? futureYears.map(String) : [],
      },
    };
    const toogleMatchePriceShow = () => {
      setIshowToggleGender(!ishowToggleGender)
    }

    //for pie chart
    function convertData(originalData) {
      let convertedData = {
        data: []
      };
    
      originalData[selectedOtherInterval]?.mData?.forEach((value, index) => {
        convertedData.data.push({ value: value, label: `M ${originalData[selectedOtherInterval]?.xLabels[index]}`, color:"#2E96FF",});
      });
    
      originalData[selectedOtherInterval]?.fData?.forEach((value, index) => {
        convertedData.data.push({ value: value, label: `F ${originalData[selectedOtherInterval]?.xLabels[index]}`,  color:"#02B2AF", });

      });
    
      return convertedData;
    }
    const convertedData = convertData(data);
    
  return (
    <>  
        <div className="row">
          <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
                <div className="card-body">
                <div className="row">
                  <div className="d-flex align-items-center justify-content-between">
                    <h4 className=""><b>{!ishowToggleGender? 'Matches played by male/female' : 'Match earnings by male/female'}</b></h4>
                    <div className="d-flex align-items-center justify-content-between">
                      <Toggle
                          className="form-control"
                          id='cheese-status'
                          defaultChecked={ishowToggleGender}
                          onChange={toogleMatchePriceShow} 
                        />
                  </div>
                    </div>
                  </div>
                  <div className="row">
                      <div className="col-md-6">
                          <BarChart
                              series={[
                                { data: data[selectedOtherInterval]?.fData, label: 'Female' },
                                { data: data[selectedOtherInterval]?.mData, label: 'Male'},
                              ]}
                              xAxis={[{ data: data[selectedOtherInterval].xLabels, scaleType: 'band' }]}
                              // width={560}
                              height={300}
                          />
                      </div>
                      <PieChart
                        series={[
                          {
                            arcLabel: (item) => `${item.label} (${item.value})`,
                            arcLabelMinAngle: 45,
                            data : convertedData?.data
                          },
                        ]}
                        sx={{
                          [`& .${pieArcLabelClasses.root}`]: {
                            fill: 'white',
                            fontSize: 10,
                          },
                        }}
                        {...sizing}
                      />
                    </div>
                </div>
            </div>
          </div>
        </div>
    </>
  );
};

